import Swiper from 'swiper';
import { Pagination, Navigation, Keyboard } from 'swiper/modules';

function initSwipers(selector, containerPrefix) {
  const elements = document.querySelectorAll(selector);

  elements.forEach((el, i) => {
    const id = i + 1;
    const containerClass = containerPrefix + '-' + id;

    el.classList.add(containerClass);

    const container = document.querySelector('.' + containerClass);
    const nextEl = container.querySelector('.swiper-button-next');
    const prevEl = container.querySelector('.swiper-button-prev');

    nextEl.classList.add('swiper-button-next-' + id);
    prevEl.classList.add('swiper-button-prev-' + id);

    new Swiper('.' + containerClass, {
      modules: [Pagination, Navigation, Keyboard],
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 24,
      keyboard: {
        enabled: true,
      },
      a11y: {
        prevSlideMessage: 'Previous slide',
        nextSlideMessage: 'Next slide',
      },
      navigation: {
        nextEl: '.swiper-button-next-' + id,
        prevEl: '.swiper-button-prev-' + id,
      },
    });
  });
}

initSwipers('.swiper-locations', 'swiper-container');
initSwipers('.swiper-events', 'swiper-events-container');
initSwipers('.swiper-posts', 'swiper-posts-container');
